<template>
	<div class="newBox">
		<div class="banner">
			<p class="txt">NEWS<br />新闻资讯</p>
		</div>
		<ul class="tabList flexBox">
			<li class="flexBox" v-for="(item,idx) in tabList" :class="tabIdx == idx ?'active':''"
				@click="clickTab(idx)">
				<img :src="item.icon" class="icon">
				<p class="txt">{{item.name}}</p>
			</li>
		</ul>

		<ul class="listBox row">
			<li v-for="(item,idx) in newList">
				<img :src="item.coverImage" class="icon">
				<div class="tag">{{item.categoryName}}</div>
				<div class="item">
					<div class="name">{{item.title}}</div>
					<div class="des">{{item.summary}}</div>
					<div class="time">{{item.createTime}}</div>
					<div class="more" @click="clickNav(item)">
						<img src="../../../assets/img/new/right.png">
					</div>
				</div>
			</li>
		</ul>
		<div class="loadBox" v-if="isShow">下滑加载更多</div>
	</div>
</template>

<script>
	export default {
		name: 'New',
		components: {

		},
		data() {
			return {
				tabIdx: 0,
				tabList: [],
				newList: [],
				pageData: {
					pageNum: 0,
					pageSize: 9,
				},
				isShow: false,
				isLoad: false,
				// 触摸事件相关变量
				startY: 0,
				endY: 0,
			}
		},
		mounted() {
			this.getData();
			// 初始化事件监听器
			this.initEventListeners();
		},
		methods: {
			getData(){
				// 获取新闻分类
				this.$req("get", "/api/cms/news/categories").then((res) => {
					this.tabList = res.data;
					this.updateList()
				});
			},
			clickTab(idx) {
				this.tabIdx = idx;	
				this.resetScroll();
				this.resetPage();
				this.updateList()
			},
			resetPage() {
				this.newList = [];
				this.isShow = false;
				this.isLoad = false;
				this.pageData.pageNum = 0;
				this.pageData.pageSize = 9;
			},
			updateList() {
				if (!this.isLoad) {
					this.isLoad = true;
					this.pageData.pageNum++;
					this.getModelList({
						res: {
							categoryId: this.tabList[this.tabIdx].id,
							pageNum: this.pageData.pageNum,
							pageSize: this.pageData.pageSize,
						},
						call: (res) => {
							this.$nextTick(() => {
								this.newList = this.newList.concat(res.rows);
								this.isLoad = false;
								// 判断是否还有更多数据可以加载
								if (this.newList.length < res.total) {
									if (!this.isShow) {
										this.isShow = true;
										this.scroll()
									}
								} else {
									if (this.isShow) {
										this.isShow = false;
										this.resetScroll();
									}
								}
							})
						}
					})
				}
			},
			clickNav(item) {
				this.$router.push({
					path:"/newDes",
					query:{
						id:item.id
					}
				})
			},
			getModelList(data) {
				this.$req("get", "/api/cms/news/pageList", {
					params: data.res
				}).then((res) => {
					data.call(res)
				});
			},
			scroll() {
				// 确保事件监听器已添加
				this.initEventListeners();
			},
			// 初始化事件监听器
			initEventListeners() {
				// 如果已经初始化过，则不再重复初始化
				if (this.touchStartHandler) {
					return;
				}
				
				// 添加滚动事件监听
				window.addEventListener("scroll", this.checkScroll);
				// 添加移动端触摸事件监听
				this.touchStartHandler = (e) => {
					this.startY = e.touches[0].pageY;
				};
				
				this.touchEndHandler = (e) => {
					this.endY = e.changedTouches[0].pageY;
					// 如果是向上滑动且接近底部，则检查是否需要加载更多
					if (this.startY > this.endY) {
						this.checkScroll();
					}
				};
				
				window.addEventListener('touchstart', this.touchStartHandler, { passive: true });
				window.addEventListener('touchend', this.touchEndHandler, { passive: true });
			},
			checkScroll() {
				// 如果已经在加载，则不继续加载
				if (this.isLoad) {
					return;
				}
				
				// 如果已经没有更多数据了，则不继续加载
				if (!this.isShow) {
					return;
				}
				
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let windowHeight = window.innerHeight;
				let documentHeight = document.documentElement.scrollHeight;
				
				if (scrollTop + windowHeight >= documentHeight - 50) {
				    this.updateList()
				}
			},
			resetScroll() {
				// 移除事件监听器
				window.removeEventListener("scroll", this.checkScroll);
				if (this.touchStartHandler) {
					window.removeEventListener('touchstart', this.touchStartHandler);
				}
				if (this.touchEndHandler) {
					window.removeEventListener('touchend', this.touchEndHandler);
				}
			},
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/new.css");
</style>